import React, { useState } from 'react';
import { Download, CheckCircle, AlertCircle, ChevronDown, ChevronUp, Calendar, Mail, Edit2, Send, User } from 'lucide-react';
export function InitechApplicationView() {
  const [expandedRef, setExpandedRef] = useState<string | null>(null);
  const [expandedGuarantor, setExpandedGuarantor] = useState<string | null>(null);
  const tradeReferences = [{
    id: 'techsupply',
    company: 'TechSupply Solutions',
    status: 'completed',
    statusText: 'Completed on April 10, 2025',
    emailsSent: '1 email sent',
    contact: {
      name: 'Robert California',
      phone: '(512) 555-0300',
      email: 'r.california@techsupply.com'
    },
    details: {
      yearsAsCustomer: 6,
      creditLimit: '$30,000',
      currentBalance: '$18,000',
      paymentHabits: 'Prompt (Net 30)',
      recommended: 'Yes',
      responseDate: 'April 10, 2025'
    }
  }, {
    id: 'servermax',
    company: 'ServerMax Distributors',
    status: 'completed',
    statusText: 'Completed on April 11, 2025',
    emailsSent: '1 email sent',
    contact: {
      name: 'Andy Bernard',
      phone: '(512) 555-0301',
      email: 'a.bernard@servermax.com'
    },
    details: {
      yearsAsCustomer: 8,
      creditLimit: '$25,000',
      currentBalance: '$15,000',
      paymentHabits: 'Prompt (Net 30)',
      recommended: 'Yes',
      responseDate: 'April 11, 2025'
    }
  }, {
    id: 'cloudware',
    company: 'CloudWare Systems',
    status: 'completed',
    statusText: 'Completed on April 9, 2025',
    emailsSent: '1 email sent',
    contact: {
      name: 'Stanley Hudson',
      phone: '(512) 555-0302',
      email: 's.hudson@cloudware.com',
      address: '890 Tech Boulevard, Dallas TX 75201'
    },
    details: {
      yearsAsCustomer: 4,
      creditLimit: '$20,000',
      currentBalance: '$12,000',
      paymentHabits: 'Prompt (Net 30)',
      recommended: 'Yes',
      responseDate: 'April 9, 2025'
    }
  }];
  return <div className="space-y-6" data-id="element-1566">
      {/* Application Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1567">
        <div className="flex items-center justify-between mb-4" data-id="element-1568">
          <div data-id="element-1569">
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1570">
              Credit Application
            </h2>
            <div className="text-sm text-gray-600 space-y-1" data-id="element-1571">
              <p data-id="element-1572">
                <span className="font-semibold" data-id="element-1573">Started On:</span> April 8, 2025
              </p>
              <p data-id="element-1574">
                <span className="font-semibold" data-id="element-1575">Submitted On:</span> April 12,
                2025
              </p>
              <p data-id="element-1576">
                <span className="font-semibold" data-id="element-1577">Approved On:</span> April 15,
                2025
              </p>
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1578">
            <Download className="w-4 h-4" data-id="element-1579" />
            DOWNLOAD PDF
          </button>
        </div>
      </div>

      {/* Applicant Details */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1580">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1581">
          Applicant Details
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1582">
          <div data-id="element-1583">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1584">
              Name
            </label>
            <p className="text-gray-900" data-id="element-1585">Milton Waddams</p>
          </div>
          <div data-id="element-1586">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1587">
              Company
            </label>
            <p className="text-gray-900" data-id="element-1588">Initech Corporation</p>
          </div>
          <div data-id="element-1589">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1590">
              Role
            </label>
            <p className="text-gray-900" data-id="element-1591">Accounts Payable</p>
          </div>
          <div data-id="element-1592">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1593">
              Department
            </label>
            <p className="text-gray-900" data-id="element-1594">Accounting</p>
          </div>
          <div data-id="element-1595">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1596">
              Email
            </label>
            <div className="flex items-center gap-2" data-id="element-1597">
              <p className="text-gray-900" data-id="element-1598">m.waddams@initech.com</p>
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-1599" />
            </div>
          </div>
          <div data-id="element-1600">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1601">
              Phone Number
            </label>
            <p className="text-gray-900" data-id="element-1602">(512) 555-0199</p>
          </div>
        </div>

        {/* Email Verification */}
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-1603">
          <div className="flex items-start gap-3" data-id="element-1604">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-1605" />
            <div data-id="element-1606">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-1607">
                Email Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-1608">
                Email verified and matches company domain.
              </p>
            </div>
          </div>
        </div>

        {/* IP Address */}
        <div className="mt-4" data-id="element-1609">
          <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1610">
            Location (IP Address)
          </label>
          <div className="flex items-center gap-2" data-id="element-1611">
            <p className="text-gray-900" data-id="element-1612">Austin, TX (192.168.1.100)</p>
            <CheckCircle className="w-4 h-4 text-green-600" data-id="element-1613" />
          </div>
        </div>

        {/* IP Verification */}
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-1614">
          <div className="flex items-start gap-3" data-id="element-1615">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-1616" />
            <div data-id="element-1617">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-1618">
                IP Address Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-1619">
                Applicant location matches company headquarters.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Company Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1620">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1621">
          Company Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1622">
          <div data-id="element-1623">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1624">
              Legal Business Name
            </label>
            <p className="text-gray-900" data-id="element-1625">Initech Corporation</p>
          </div>
          <div data-id="element-1626">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1627">
              DBA
            </label>
            <p className="text-gray-900" data-id="element-1628">Initech</p>
          </div>
          <div data-id="element-1629">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1630">
              Business Address
            </label>
            <p className="text-gray-900" data-id="element-1631">
              4120 Freidrich Lane
              <br data-id="element-1632" />
              Austin, TX 78744
            </p>
          </div>
          <div data-id="element-1633">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1634">
              Years in Business
            </label>
            <p className="text-gray-900" data-id="element-1635">33 years</p>
          </div>
          <div data-id="element-1636">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1637">
              Tax ID / EIN
            </label>
            <p className="text-gray-900" data-id="element-1638">**-***7291</p>
          </div>
          <div data-id="element-1639">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1640">
              Industry
            </label>
            <p className="text-gray-900" data-id="element-1641">Software & IT Services</p>
          </div>
        </div>
      </div>

      {/* Requested Credit Terms */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1642">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1643">
          Requested Credit Terms
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1644">
          <div data-id="element-1645">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1646">
              Requested Credit Limit
            </label>
            <p className="text-gray-900 text-lg font-semibold" data-id="element-1647">$75,000</p>
          </div>
          <div data-id="element-1648">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1649">
              Payment Terms
            </label>
            <p className="text-gray-900" data-id="element-1650">Net 30</p>
          </div>
          <div data-id="element-1651">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1652">
              Estimated Monthly Volume
            </label>
            <p className="text-gray-900" data-id="element-1653">$25,000 - $30,000</p>
          </div>
          <div data-id="element-1654">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1655">
              Purpose
            </label>
            <p className="text-gray-900" data-id="element-1656">IT equipment and software licenses</p>
          </div>
        </div>
      </div>

      {/* Trade References */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1657">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1658">
          Trade References
        </h3>
        <div className="space-y-3" data-id="element-1659">
          {tradeReferences.map(ref => <div key={ref.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1660">
              {/* Collapsed Header */}
              <button onClick={() => setExpandedRef(expandedRef === ref.id ? null : ref.id)} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1661">
                <div className="flex items-center gap-4" data-id="element-1662">
                  <span className="font-semibold text-gray-900" data-id="element-1663">
                    {ref.company}
                  </span>
                  <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-1664">
                    <div className="flex items-center gap-1" data-id="element-1665">
                      <Calendar className="w-4 h-4" data-id="element-1666" />
                      {ref.statusText}
                    </div>
                    {ref.emailsSent && <>
                        <span className="text-gray-300" data-id="element-1667">•</span>
                        <div className="flex items-center gap-1" data-id="element-1668">
                          <Mail className="w-4 h-4" data-id="element-1669" />
                          {ref.emailsSent}
                        </div>
                      </>}
                  </div>
                </div>
                {expandedRef === ref.id ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1670" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1671" />}
              </button>

              {/* Expanded Content */}
              {expandedRef === ref.id && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-1672">
                  {/* Reference Information */}
                  <div className="mb-6" data-id="element-1673">
                    <div className="flex items-center gap-2 mb-4" data-id="element-1674">
                      <span className="font-semibold text-gray-900" data-id="element-1675">
                        Reference Information
                      </span>
                      <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-1676" />
                    </div>
                    <div className="grid grid-cols-2 gap-6" data-id="element-1677">
                      <div data-id="element-1678">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1679">
                          Company Name
                        </label>
                        <p className="text-gray-900" data-id="element-1680">{ref.company}</p>
                      </div>
                      <div data-id="element-1681">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1682">
                          Contact Name
                        </label>
                        <p className="text-gray-900" data-id="element-1683">{ref.contact.name}</p>
                      </div>
                      <div data-id="element-1684">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1685">
                          Contact Phone Number
                        </label>
                        <p className="text-gray-900" data-id="element-1686">{ref.contact.phone}</p>
                      </div>
                      <div data-id="element-1687">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1688">
                          Contact Work Email
                        </label>
                        <p className="text-gray-900" data-id="element-1689">{ref.contact.email}</p>
                      </div>
                      {ref.contact.address && <div className="col-span-2" data-id="element-1690">
                          <label className="text-sm text-gray-500 mb-1 block" data-id="element-1691">
                            Company Address
                          </label>
                          <p className="text-gray-900" data-id="element-1692">{ref.contact.address}</p>
                        </div>}
                    </div>
                  </div>

                  {/* Status-specific content */}
                  {ref.status === 'pending' && <div data-id="element-1693">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-1694">
                        Awaiting Response
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1695">
                        The reference request has been sent 2 times.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1696">
                        <Send className="w-4 h-4" data-id="element-1697" />
                        SEND REMINDER
                      </button>
                    </div>}

                  {ref.status === 'completed' && ref.details && <div data-id="element-1698">
                      <div className="flex items-center gap-2 mb-4" data-id="element-1699">
                        <div className="font-semibold text-gray-900" data-id="element-1700">
                          Reference Completed
                        </div>
                        <AlertCircle className="w-5 h-5 text-red-600" data-id="element-1701" />
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1702">
                        Response received on {ref.details.responseDate}
                      </p>
                      <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-1703">
                        <div className="flex justify-between" data-id="element-1704">
                          <span className="text-gray-600" data-id="element-1705">
                            Years as Customer
                          </span>
                          <span className="font-medium text-gray-900" data-id="element-1706">
                            {ref.details.yearsAsCustomer}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1707">
                          <span className="text-gray-600" data-id="element-1708">Credit Limit</span>
                          <span className="font-medium text-gray-900" data-id="element-1709">
                            {ref.details.creditLimit}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1710">
                          <span className="text-gray-600" data-id="element-1711">Current Balance</span>
                          <span className="font-medium text-gray-900" data-id="element-1712">
                            {ref.details.currentBalance}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1713">
                          <span className="text-gray-600" data-id="element-1714">Payment Habits</span>
                          <span className="font-medium text-red-600" data-id="element-1715">
                            {ref.details.paymentHabits}
                          </span>
                        </div>
                        <div className="flex justify-between col-span-2" data-id="element-1716">
                          <span className="text-gray-600" data-id="element-1717">Recommended</span>
                          <span className="font-medium text-red-600" data-id="element-1718">
                            {ref.details.recommended}
                          </span>
                        </div>
                      </div>
                    </div>}

                  {ref.status === 'not-sent' && <div data-id="element-1719">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-1720">
                        Ready to Send
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1721">
                        This trade reference request has not yet been sent to
                        the contact.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1722">
                        <Send className="w-4 h-4" data-id="element-1723" />
                        SEND REFERENCE
                      </button>
                    </div>}
                </div>}
            </div>)}
        </div>

        {/* Additional Trade References */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-1724">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-1725">
            Additional Trade References
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-1726">
            No additional references requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1727">
            <Send className="w-4 h-4" data-id="element-1728" />
            REQUEST ADDITIONAL TRADE REFERENCES
          </button>
        </div>
      </div>

      {/* Personal Guarantors */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1729">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1730">
          Personal Guarantors
        </h3>
        <div className="space-y-3" data-id="element-1731">
          {/* Bill Lumbergh - Completed */}
          <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1732">
            {/* Collapsed Header */}
            <button onClick={() => setExpandedGuarantor(expandedGuarantor === 'bill' ? null : 'bill')} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1733">
              <div className="flex items-center gap-4" data-id="element-1734">
                <span className="font-semibold text-gray-900" data-id="element-1735">
                  Bill Lumbergh
                </span>
                <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-1736">
                  <div className="flex items-center gap-1" data-id="element-1737">
                    <Calendar className="w-4 h-4" data-id="element-1738" />
                    Completed on February 15, 2026
                  </div>
                  <span className="text-gray-300" data-id="element-1739">•</span>
                  <div className="flex items-center gap-1" data-id="element-1740">
                    <Mail className="w-4 h-4" data-id="element-1741" />1 email sent
                  </div>
                </div>
              </div>
              {expandedGuarantor === 'bill' ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1742" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1743" />}
            </button>

            {/* Expanded Content */}
            {expandedGuarantor === 'bill' && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-1744">
                {/* Guarantor Information */}
                <div className="mb-6" data-id="element-1745">
                  <div className="flex items-center gap-2 mb-4" data-id="element-1746">
                    <User className="w-4 h-4 text-gray-600" data-id="element-1747" />
                    <span className="font-semibold text-gray-900" data-id="element-1748">
                      Guarantor Information
                    </span>
                    <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-1749" />
                  </div>
                  <div className="grid grid-cols-2 gap-6" data-id="element-1750">
                    <div data-id="element-1751">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1752">
                        Full Name
                      </label>
                      <p className="text-gray-900" data-id="element-1753">Bill Lumbergh</p>
                    </div>
                    <div data-id="element-1754">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1755">
                        Title
                      </label>
                      <p className="text-gray-900" data-id="element-1756">VP Operations</p>
                    </div>
                    <div data-id="element-1757">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1758">
                        Email
                      </label>
                      <p className="text-gray-900" data-id="element-1759">b.lumbergh@initech.com</p>
                    </div>
                    <div data-id="element-1760">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1761">
                        Phone
                      </label>
                      <p className="text-gray-900" data-id="element-1762">(512) 555-0200</p>
                    </div>
                    <div data-id="element-1763">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1764">
                        Address
                      </label>
                      <p className="text-gray-900" data-id="element-1765">
                        4120 Freidrich Lane, Austin, TX 78744
                      </p>
                    </div>
                    <div data-id="element-1766">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1767">
                        SSN
                      </label>
                      <p className="text-gray-900" data-id="element-1768">***-**-8291</p>
                    </div>
                  </div>
                </div>

                {/* Guarantee Completed */}
                <div data-id="element-1769">
                  <div className="flex items-center gap-2 mb-4" data-id="element-1770">
                    <div className="font-semibold text-gray-900" data-id="element-1771">
                      Guarantee Completed
                    </div>
                    <CheckCircle className="w-5 h-5 text-green-600" data-id="element-1772" />
                  </div>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-1773">
                    Personal guarantee signed on February 15, 2026
                  </p>
                  <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-1774">
                    <div className="flex justify-between" data-id="element-1775">
                      <span className="text-gray-600" data-id="element-1776">Guarantee Amount</span>
                      <span className="font-medium text-gray-900" data-id="element-1777">$75,000</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1778">
                      <span className="text-gray-600" data-id="element-1779">Date Signed</span>
                      <span className="font-medium text-gray-900" data-id="element-1780">
                        February 15, 2026
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1781">
                      <span className="text-gray-600" data-id="element-1782">Guarantee Type</span>
                      <span className="font-medium text-gray-900" data-id="element-1783">
                        Unlimited
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1784">
                      <span className="text-gray-600" data-id="element-1785">Expiration</span>
                      <span className="font-medium text-gray-900" data-id="element-1786">None</span>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>

        {/* Additional Personal Guarantors */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-1787">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-1788">
            Additional Personal Guarantors
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-1789">
            No additional guarantors requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1790">
            <Send className="w-4 h-4" data-id="element-1791" />
            REQUEST ADDITIONAL PERSONAL GUARANTORS
          </button>
        </div>
      </div>

      {/* Banking Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1792">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1793">
          Banking Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1794">
          <div data-id="element-1795">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1796">
              Bank Name
            </label>
            <p className="text-gray-900" data-id="element-1797">Austin Community Bank</p>
          </div>
          <div data-id="element-1798">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1799">
              Contact
            </label>
            <p className="text-gray-900" data-id="element-1800">Jennifer Aniston</p>
          </div>
          <div data-id="element-1801">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1802">
              Type of Account
            </label>
            <p className="text-gray-900" data-id="element-1803">Business Checking</p>
          </div>
          <div data-id="element-1804">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1805">
              Account #
            </label>
            <p className="text-gray-900" data-id="element-1806">987654321</p>
          </div>
          <div data-id="element-1807">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1808">
              Email
            </label>
            <p className="text-gray-900" data-id="element-1809">j.aniston@austinbank.com</p>
          </div>
          <div data-id="element-1810">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1811">
              City
            </label>
            <p className="text-gray-900" data-id="element-1812">Austin</p>
          </div>
          <div data-id="element-1813">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1814">
              State
            </label>
            <p className="text-gray-900" data-id="element-1815">TX</p>
          </div>
          <div data-id="element-1816">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1817">
              Phone #
            </label>
            <p className="text-gray-900" data-id="element-1818">512-555-0400</p>
          </div>
          <div data-id="element-1819">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1820">
              Fax #
            </label>
            <p className="text-gray-900" data-id="element-1821">512-555-0401</p>
          </div>
        </div>
      </div>

      {/* Signature */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1822">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1823">Signature</h3>

        {/* Terms & Conditions */}
        <div className="mb-6" data-id="element-1824">
          <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1825">
            Terms & Conditions
          </h4>
          <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg mb-4" data-id="element-1826">
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1827">
              I understand that should my account become delinquent (terms of
              sale are based upon date of invoice) and that if the creditor
              elects to employ a third party to collect monies due, my company
              will be responsible for not only the original amount billed, but
              also all costs associated with the collection efforts including
              but not limited to reasonable attorney fees. Cash in Advance
              restrictions may be placed on any past due account. Customer will
              notify the creditor, in writing of any ownership changes or legal
              means of doing business by the company under which credit was
              established.
            </p>
          </div>
          <p className="text-sm font-semibold text-gray-900 mb-6" data-id="element-1828">
            By signing the below you give Initech Corporation permission to
            check your bank and trade references.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1829">
          <div data-id="element-1830">
            <label className="text-sm font-medium text-gray-500 mb-2 block" data-id="element-1831">
              Signature
            </label>
            <div className="border-2 border-gray-300 rounded-lg p-4 bg-white h-32 flex items-center justify-center" data-id="element-1832">
              <svg viewBox="0 0 200 60" className="w-full h-full" style={{
              maxWidth: '200px'
            }} data-id="element-1833">
                <path d="M 10 40 Q 20 20, 40 35 T 80 30 Q 100 25, 120 40 T 160 35 Q 170 30, 190 40" stroke="#1f2937" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-1834" />
              </svg>
            </div>
          </div>
          <div data-id="element-1835">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1836">
              Printed Name
            </label>
            <p className="text-gray-900" data-id="element-1837">Peter Gibbons</p>
          </div>
          <div data-id="element-1838">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1839">
              Title
            </label>
            <p className="text-gray-900" data-id="element-1840">Software Engineer</p>
          </div>
          <div data-id="element-1841">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1842">
              Date
            </label>
            <p className="text-gray-900" data-id="element-1843">2026-02-15</p>
          </div>
        </div>
      </div>
    </div>;
}